import { ActionTypes } from "../../constants/ActionTypes";

export const onSetUrl = (params: any) => {
  return {
    type: ActionTypes.SET_BPM_URL,
    payload: params,
  };
};

export const onGetBpmNewCaseUrl = (params: any) => {
  return {
    type: ActionTypes.GET_BPM_NEW_CASE_URL,
    payload: params,
  };
};

export const fetchBpmNewCaseUrlSuccess = (data: any) => {
  return {
    type: ActionTypes.FETCH_BPM_NEW_CASE_URL_SUCCESS,
    payload: data,
  };
};
